import React, { useEffect, useState } from "react";
import Page from "src/components/Page";
import { getDeclaraciones } from "src/utils/req.declaracion";
import { notification } from "antd";
import TablePersonal from "../DeclaracionPersonal/components/TablePersonal";
import DetailSalud from "./components/DetailSalud";

const DeclaracionSalud = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [details, setDetails] = useState({ open: false, data: {} });

  useEffect(() => {
    obtainData();
  }, []);

  const obtainData = async () => {
    setLoading(true);
    try {
      const res = await getDeclaraciones("salud");
      setData([...res]);
    } catch (error) {
      notification["error"]({
        message: `Ocurrió un error al realizar la operación`,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page helper="DECLARACIÓN JURADA" title="Declaración jurada de salud">
      <TablePersonal data={data} loading={loading} setDetails={setDetails} />

      {details.open && <DetailSalud open={details.open} setOpen={setDetails} data={details.data} />}
    </Page>
  );
};

export default DeclaracionSalud;
